<template>
  <div class="d-flex justify-content-between align-items-center">
    {{ technician ? technician.full_name : "--" }}
    <Tooltip
      v-if="technician && technician.archived_at"
      placement="top"
      :options="{ hideOnClick: true }"
    >
      <template #trigger>
        <i class="fas fa-archive ml-2 text-gray"></i>
      </template>
      <template #tooltip>
        <div class="text-center">Archived</div>
      </template>
    </Tooltip>
    <Tooltip placement="top" :options="{ hideOnClick: true }">
      <template #trigger>
        <i class="fas fa-edit ml-2 link" @click="toggleModal"></i>
      </template>
      <template #tooltip>
        <div class="text-center p-2">
          Change opportunity<br />
          owner & status
        </div>
      </template>
    </Tooltip>
    <job-opportunity-modal
      v-if="ownerModal"
      :job-id="jobId"
      :technician="technician"
      :opportunity-status="opportunityStatus"
      :lead-type="leadType"
      :lead-source="leadSource"
      @hide-modal="toggleModal"
    ></job-opportunity-modal>
  </div>
</template>

<script>
import JobOpportunityModal from "./JobOpportunityModal.vue";
import Tooltip from "../../components/Tooltip.vue";
export default {
  components: {
    JobOpportunityModal,
    Tooltip
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    opportunityStatus: {
      type: String,
      default: ""
    },
    leadType: {
      type: String,
      default: ""
    },
    leadSource: {
      type: String,
      default: ""
    },
    technician: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ownerModal: false
    };
  },
  methods: {
    toggleModal() {
      this.ownerModal = !this.ownerModal;
    }
  }
};
</script>

<style lang="scss" scoped></style>
